// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-progress-box-2022-4-11 .el-progress__text {\n  font-size: 16px !important;\n}\n", ""]);
// Exports
module.exports = exports;
